import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService, CmsService, UserIdService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CartExtendService, DownloadCsvPayload } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';
@Component({
  selector: 'app-cart-export',
  templateUrl: './cart-export.component.html',
  styleUrls: ['./cart-export.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CartExportComponent implements OnInit, OnDestroy {
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  constructor(
    private cartService: CartExtendService,
    private cmsService: CmsService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    protected auth: AuthService,
    private userIdService: UserIdService
  ) {}
  @Input()
  cartId: string;
  showSrp = false;
  srpSubscription$: Subscription;
  currentPageSubscription$: Subscription;
  pageId: string;

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }
  ngOnInit() {
    this.getInitSrpToggleValue();

    this.currentPageSubscription$ = this.cmsService.getCurrentPage().subscribe((currentPage) => {
      if (currentPage && currentPage.pageId) {
        this.pageId = currentPage.pageId;
      }
    });

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });
  }

  downloadCartCsv() {
    const payload: DownloadCsvPayload = {
      userId: this.userCurrent,
      cartId: this.cartId,
    };

    this.cartService.downloadCartCsv(payload).subscribe();
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  ngOnDestroy() {
    if (this.currentPageSubscription$) {
      this.currentPageSubscription$.unsubscribe();
    }
    if (this.srpSubscription$) {
      this.srpSubscription$.unsubscribe();
    }
  }
}
